{
	"title": "Notes",
	"list": {
		"title": "Notes",
		"subtitle": "{notes, plural, one {# note} other {# notes}} · {materials, plural, one {# material} other {# materials}}",
		"empty": "No notes yet",
		"emptyDescription": "Upload a material — we'll generate a structured note in three detail levels.",
		"emptyFiltered": "Nothing matches your filters",
		"resetFilters": "Reset filters",
		"create": "Create note",
		"showMore": "Show more",
		"errorTitle": "Couldn't load notes",
		"errorHint": "Check your connection or try again.",
		"noSource": "No source",
		"statusGenerating": "Generating",
		"statusFailed": "Failed",
		"generatingHint": "AI is drafting the note… This usually takes 1–2 minutes.",
		"generationFailedHint": "Generation failed. Open to retry.",
		"aiBlocksCount": "{count, plural, one {# AI block} other {# AI blocks}}",
		"actions": {
			"generate": "Generate",
			"createBlank": "Create blank",
			"createMenu": "New note",
			"createBlankFull": "Create blank note",
			"generateFull": "Generate from material"
		},
		"swipeDelete": "Delete",
		"filters": {
			"searchPlaceholder": "Search notes…",
			"material": "Material",
			"allMaterials": "All materials",
			"detailLevel": "Detail level",
			"allLevels": "All levels",
			"date": "Date",
			"any": "All time",
			"today": "Today",
			"week": "7 days",
			"month": "30 days",
			"view": "View",
			"sheetTitle": "Filters",
			"trigger": "Filters",
			"triggerCount": "Filters · {count}",
			"apply": "Show results"
		}
	},
	"detailLevel": {
		"summarized": "Summarized",
		"inDepth": "In-depth",
		"comprehensive": "Comprehensive",
		"manual": "Manual"
	},
	"detailLevels": {
		"label": "Detail level",
		"summarized": "Summarized",
		"summarizedDescription": "Key ideas and main points",
		"inDepth": "In-depth",
		"inDepthDescription": "All key concepts with examples",
		"comprehensive": "Comprehensive",
		"comprehensiveDescription": "Full material breakdown"
	},
	"generate": {
		"title": "Generate note",
		"fields": {
			"material": "Material",
			"materialPlaceholder": "Pick a material…",
			"detailLevel": "Detail level",
			"locale": "Note language",
			"localeHint": "Matches material language",
			"customInstructions": "Wishes for the note",
			"customInstructionsPlaceholder": "E.g.: focus on internecine wars, add detailed tables and diagrams…",
			"customInstructionsHint": "Optional. AI will take your wishes into account during generation.",
			"materialEmpty": "No materials",
			"materialEmptyHint": "Upload a material first — the note is built from it."
		},
		"levels": {
			"summarized": {
				"label": "Summarized",
				"pages": "~5–8 pages",
				"description": "Main theses for quick review",
				"time": "~1–2 min"
			},
			"inDepth": {
				"label": "In-depth",
				"pages": "~10–20 pages",
				"description": "Detailed breakdown with examples and sources",
				"time": "~2–4 min"
			},
			"comprehensive": {
				"label": "Comprehensive",
				"pages": "20–40+ pages",
				"description": "Maximum detail, glossary, AI blocks",
				"time": "~4–8 min"
			}
		},
		"proOnly": "PRO",
		"submit": "Generate",
		"submitting": "Creating…",
		"toastStarted": "Generation started — about 2 min",
		"toastError": "Could not start generation. Please try again.",
		"toastSlow": "The note is taking longer than usual — it will appear in your notes list as soon as it's ready.",
		"locked": "Unavailable"
	},
	"generation": {
		"starting": "Generating note…",
		"inProgress": "Generating note",
		"stage": "Stage: {stage}",
		"ready": "Note ready",
		"failed": "Failed to generate note",
		"retry": "Regenerate"
	},
	"editor": {
		"placeholder": "Start writing or use / for commands…",
		"starter": {
			"whatTitle": "What it is and why it matters",
			"whatBody": "This is the central node of the topic. Memorize the key ideas and test yourself with flashcards.",
			"stagesTitle": "Stages",
			"stage1": "First stage",
			"stage2": "Second stage",
			"stage3": "Third stage"
		},
		"untitled": "Untitled",
		"back": "Notes",
		"backToMaterial": "Material",
		"history": "Version history",
		"regenerate": "Regenerate",
		"regenerateManualHint": "Available only for notes generated from a material",
		"more": "More",
		"wordCount": "{count, plural, one {# word} other {# words}}",
		"readingMin": "{count, plural, one {# min read} other {# min read}}",
		"autosave": {
			"pending": "Saving…",
			"saved": "Autosaved just now",
			"savedAgo": "Autosaved {seconds} sec ago",
			"offline": "Saved locally · sync pending",
			"failed": "Failed to save"
		},
		"errorTitle": "Couldn't open note",
		"errorHint": "It may have been deleted or you don't have access.",
		"backToList": "Back to list",
		"regeneratingTitle": "Regenerating note",
		"regeneratingHint": "AI is rebuilding the note — this takes a couple of minutes. The new version will appear here automatically.",
		"regenerateTimeout": "Generation is taking longer than usual. Refresh the page to see the result.",
		"generatingTitle": "Generating note",
		"generatingHint": "AI is composing a structured note — this takes a few seconds. The page will update automatically.",
		"offlineBanner": "Offline — changes are saved locally and will sync later.",
		"image": {
			"loadFailed": "Couldn't load image",
			"unsupportedType": "Unsupported format. Upload PNG, JPEG, WebP, or GIF.",
			"tooLarge": "File is too large. Maximum is 10 MB.",
			"uploadFailed": "Couldn't upload image",
			"zoom": "Open image fullscreen",
			"close": "Close"
		},
		"mermaid": {
			"label": "Diagram",
			"preview": "Preview",
			"code": "Code",
			"sourceLabel": "Diagram source",
			"placeholder": "graph TD; A --> B"
		},
		"citation": {
			"page": "p. {n}",
			"source": "source",
			"chunkOrder": "Fragment {n}",
			"groupAria": "{count, plural, one {# source: {name}} other {# sources: {name}}}",
			"snippetUnavailable": "The fragment text is not loaded yet."
		},
		"slash": {
			"searchPlaceholder": "Search command…",
			"groups": {
				"ai": "AI",
				"content": "Content",
				"format": "Format"
			},
			"items": {
				"ai": "AI block",
				"explain": "Explain selection",
				"summary": "Brief summary",
				"question": "Ask a question",
				"example": "Give an example",
				"critique": "Critique",
				"translate": "Translate",
				"expand": "Expand",
				"flashcards": "Generate flashcards",
				"quiz": "Generate quiz",
				"cite": "Insert citation",
				"glossary": "Add to glossary",
				"h1": "Heading 1",
				"h2": "Heading 2",
				"h3": "Heading 3",
				"bullet": "Bulleted list",
				"ordered": "Numbered list",
				"todo": "Task list",
				"callout": "Callout",
				"quote": "Blockquote",
				"code": "Code block",
				"table": "Table 3×3",
				"image": "Image",
				"video": "Video",
				"hr": "Divider"
			},
			"prompts": {
				"ai": "Explain in simple words",
				"explain": "Explain the selection for an 8th grader",
				"summary": "Brief summary",
				"question": "Ask a question",
				"example": "Give a concrete example of this idea",
				"critique": "Point out gaps and weak spots",
				"translate": "Translate the selection",
				"expand": "Expand with more detail",
				"demoKrebs": "Explain the Krebs cycle for an 8th grader"
			},
			"kbd": {
				"navigate": "navigate",
				"select": "select",
				"close": "close"
			}
		},
		"aiBlock": {
			"ariaLabel": "AI block: {type}",
			"regen": "Regenerate",
			"delete": "Delete",
			"pin": "Pin as main",
			"insertAsText": "Insert as plain text",
			"editPrompt": "Edit prompt",
			"promptLabel": "Prompt",
			"variant": "Variant {current} of {total}",
			"stream": "stream",
			"types": {
				"visualAnalysis": "Image analysis",
				"explain": "Explanation",
				"summary": "Summary",
				"question": "Question",
				"example": "Example",
				"critique": "Critique",
				"translate": "Translation",
				"expand": "Expanded",
				"ai": "AI"
			}
		},
		"toolbar": {
			"bold": "Bold",
			"italic": "Italic",
			"underline": "Underline",
			"strike": "Strikethrough",
			"code": "Code",
			"heading": "Heading",
			"paragraph": "Paragraph",
			"bulletList": "Bullet list",
			"orderedList": "Numbered list",
			"taskList": "Task list",
			"quote": "Quote",
			"align": "Text align",
			"alignLeft": "Align left",
			"alignCenter": "Align center",
			"alignRight": "Align right",
			"highlight": "Highlight",
			"link": "Link",
			"image": "Image",
			"video": "Video",
			"table": "Table",
			"slash": "Commands",
			"hl": {
				"yellow": "Yellow",
				"green": "Green",
				"pink": "Pink",
				"blue": "Blue",
				"purple": "Purple",
				"clear": "Clear highlight"
			},
			"linkDialog": {
				"title": "Insert link",
				"urlLabel": "URL",
				"urlPlaceholder": "https://...",
				"insert": "Insert",
				"cancel": "Cancel",
				"remove": "Remove link"
			}
		},
		"bubble": {
			"ariaLabel": "Text formatting",
			"clear": "Clear formatting",
			"ai": "Ask AI about selection"
		},
		"composer": {
			"title": "AI: {type}",
			"editTitle": "Edit prompt",
			"promptLabel": "Prompt",
			"contextLabel": "Context",
			"noContext": "No text selected — the model will answer a free-form request.",
			"languageLabel": "Target language",
			"cancel": "Cancel",
			"create": "Create",
			"save": "Save"
		},
		"video": {
			"dialogTitle": "Insert video",
			"tabLink": "Link",
			"tabFile": "File",
			"urlLabel": "Video URL",
			"urlPlaceholder": "YouTube or Vimeo link",
			"insert": "Insert",
			"cancel": "Cancel",
			"invalidUrl": "This host is not supported. Use YouTube or Vimeo.",
			"unsupportedType": "Unsupported format. Upload MP4, WebM, or MOV.",
			"tooLarge": "File is too large. Maximum is 50 MB.",
			"uploadFailed": "Couldn't upload video",
			"loadFailed": "Couldn't load video",
			"fileHint": "A short clip in the note, up to 50 MB (MP4, WebM, MOV).",
			"chooseFile": "Choose file"
		},
		"dragHandle": {
			"ariaLabel": "Drag block"
		},
		"toc": {
			"title": "Outline",
			"ariaLabel": "Table of contents",
			"open": "Open outline"
		},
		"renameTitleAria": "Rename note",
		"renameDialog": {
			"title": "Rename note",
			"placeholder": "Note title",
			"submit": "Save",
			"success": "Note renamed",
			"error": "Failed to rename"
		},
		"voice": {
			"input": "Voice input",
			"recording": "Recording… (tap to stop)",
			"transcribing": "Transcribing…",
			"permissionDenied": "Microphone access denied",
			"notSupported": "Voice input is not supported in this browser",
			"empty": "Recording was empty — try again",
			"failed": "Could not recognize speech",
			"noSpeech": "Couldn't catch any speech"
		},
		"table": {
			"grip": {
				"row": "Select row",
				"column": "Select column",
				"table": "Select table"
			},
			"add": {
				"row": "Insert row",
				"column": "Insert column"
			},
			"row": {
				"toggleHeader": "Header row",
				"insertAbove": "Insert above",
				"insertBelow": "Insert below",
				"moveUp": "Move up",
				"moveDown": "Move down",
				"delete": "Delete row"
			},
			"column": {
				"toggleHeader": "Header column",
				"insertLeft": "Insert left",
				"insertRight": "Insert right",
				"moveLeft": "Move left",
				"moveRight": "Move right",
				"delete": "Delete column",
				"sortAsc": "Sort ascending",
				"sortDesc": "Sort descending",
				"sortDisabledMerged": "Unavailable: table contains merged cells"
			},
			"align": {
				"label": "Alignment",
				"left": "Align left",
				"center": "Align center",
				"right": "Align right"
			},
			"cells": {
				"merge": "Merge cells",
				"split": "Split cell"
			},
			"bg": {
				"label": "Background",
				"title": "Cell background",
				"none": "None",
				"amber": "Amber",
				"green": "Green",
				"blue": "Blue",
				"rose": "Rose",
				"slate": "Slate"
			},
			"table": {
				"distribute": "Distribute columns",
				"toggleHeaderRow": "Header row",
				"delete": "Delete table"
			},
			"menu": {
				"row": "Row actions",
				"column": "Column actions",
				"table": "Table actions",
				"cells": "Cell actions"
			},
			"mobile": {
				"title": "Table",
				"more": "More",
				"insertRowAbove": "Row above",
				"insertRowBelow": "Row below",
				"insertColumnLeft": "Column left",
				"insertColumnRight": "Column right"
			}
		},
		"editMode": "Edit",
		"readMode": "Done"
	},
	"versions": {
		"title": "Version history",
		"subtitle": "{title}",
		"empty": "This is the only version",
		"emptyHint": "Regeneration or manual save creates a snapshot.",
		"selected": "selected",
		"current": "Current",
		"restore": "Restore this version",
		"reasons": {
			"manual_save": "Auto-saved",
			"ai_regenerate": "Regeneration",
			"restore": "Restored",
			"current": "Current version"
		},
		"restored": "Version restored",
		"restoreFailed": "Failed to restore version",
		"previewEmpty": "This version has no content",
		"authorAi": "AI",
		"authorYou": "You",
		"diff": {
			"changes": "Changes",
			"preview": "Preview",
			"toggle": "Version view",
			"identical": "This version is identical to the current one",
			"collapsed": "··· {count, plural, one {# unchanged line} other {# unchanged lines}} ···"
		}
	},
	"glossaryTooltip": {
		"viewDefinition": "View definition",
		"tapHint": "Tap a term to see its definition"
	},
	"glossaryAdd": {
		"title": "Add to glossary",
		"description": "The term and definition will appear in the material's glossary and be highlighted in the note.",
		"termLabel": "Term",
		"termPlaceholder": "For example: Krebs cycle",
		"definitionLabel": "Definition",
		"definitionPlaceholder": "A brief explanation of the term",
		"submit": "Add",
		"added": "Term added to glossary",
		"failed": "Failed to add term"
	},
	"actions": {
		"regenerate": "Regenerate",
		"duplicate": "Duplicate",
		"export": "Export",
		"exportPdf": "Export as PDF",
		"exportMarkdown": "Export as Markdown",
		"delete": "Delete",
		"openMaterial": "Open material",
		"rename": "Rename"
	},
	"wordCount": "{count, plural, one {# word} other {# words}}",
	"workspace": {
		"backToMaterial": "Back to material",
		"notesTab": "Notes",
		"notesTitle": "Material notes",
		"generateTitle": "Generate AI note",
		"empty": "No notes for this material yet. Generate one or create manually.",
		"open": "Open",
		"genFailed": "Couldn't start generation",
		"generatingHint": "The note is being generated — it may take up to a minute. It will open automatically."
	},
	"savedAnswer": {
		"badge": "Saved reply",
		"untitled": "Saved reply",
		"back": "Back",
		"viewOnly": "Saved replies are view only — the text stays exactly as the tutor wrote it.",
		"convertToSource": "Make it a source",
		"convertUnavailable": "This reply isn’t linked to a course, so there is nothing to add it to.",
		"convertSuccess": "Added to the course sources",
		"convertNotAttached": "The material was created, but not added to the course",
		"convertNotAttachedHint": "Find it in your library and add it to the course by hand.",
		"convertFailed": "Could not create the material",
		"materialCreated": "Open the material",
		"openConversation": "Open the conversation",
		"convertDone": "Added to the course sources"
	},
	"intro": {
		"title": "A note is not a copy of the source",
		"body": "A condensed retelling of your source: the AI writes it, you edit it like any document. Links back to the original fragments stay in place.",
		"bullets": [
			"Three depth levels, from a digest to a full breakdown",
			"Every point links to the fragment it came from",
			"Version history — any edit can be rolled back"
		]
	}
}
